import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsTopRisksReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'topRisksReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/top_risks_reports',
        { top_risks_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
